import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

interface StyledRingProps {
  size: number;
}

const RingContainer = styled(Box)<StyledRingProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`;

interface ScoreRingProps {
  display?: string;
  score: number;
  size?: number; // Optional size, defaults to 80
  strokeColor?: string;
}

export const ScoreRing = ({ display, score, size = 80, strokeColor = '#f97316' }: ScoreRingProps) => {
  const percentage = Math.min(Math.max((score / 10) * 100, 0), 100);
  const fontSize = `${size * 0.28}px`;

  return (
    <RingContainer size={size}>
      <svg width={size} height={size} viewBox='0 0 36 36'>
        <path
          stroke='#e2e8f0'
          strokeWidth='3'
          fill='none'
          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
        />
        <path
          stroke={strokeColor}
          strokeWidth='3'
          strokeDasharray={`${percentage}, 100`}
          fill='none'
          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
        />
      </svg>
      <Typography sx={{ position: 'absolute', fontWeight: 800, fontSize, color: '#1e293b' }}>
        {display ? display : score}
      </Typography>
    </RingContainer>
  );
};
